import React from "react"
import { appTools, cn } from "lib/utils"
import { appStore } from "lib/state"
import { SectionTitle, useConditional } from "lib/units/conditional"

export default function Welcome({ className }:{ className?:string }){

  const { store }:any = appStore()
  const { showdocs, hidedocs }:any = useConditional() 

  return (
    <div className={cn("w-full pt-6", className)}>
      <SectionTitle title="conditional editing" className="top-[-7px]" />

      { store.metas.docsvisible === false ? (
        <div className="px-8">
          <p>To get started, click on an existing conditional group at left, or click the Plus icon to create a new one.</p>
          {/* <p>If you're here for the help docs, just <span onClick={showdocs} className="text-amber-600 cursor-pointer">click here</span>.</p> */}
        </div>
      ) : (
        <div className="px-8">
          <p>These will be added later, assuming Amber stops bugging me.</p>
        </div>
      )}

    </div>
  )

}